import { createSelector } from 'reselect'

// Simple selectors
const selectPreferencesState = (state) => state.preferences || {}
const selectProfileState = (state) => state.profile || {}

// Memoized selectors
export const selectPreferencesData = createSelector(
  [selectPreferencesState],
  (preferences) => ({
    loading: preferences.loading || false,
    preferences: preferences.preferences || [],
    userPreferences: preferences.userPreferences || [],
    error: preferences.error || null
  })
)

// Selector for the profile slice
export const selectProfile = createSelector(
  [selectProfileState],
  (profile) => ({
    loading: profile.loading || false,
    updating: profile.updating || false,
    profile: profile.profile || null,
    error: profile.error || null
  })
)
